/**
 * Show more tools.
 */
H_Tools.show_more = (() => {
    /**
     * Toggles the supplied show more button state.
     *
     * @param {*} button  A show more button element
     * @param {*} content A show more content element associated with the button
     */
    function buttonPressed(button, content) {
        const open = button.getAttribute('aria-expanded') === 'true';

        if (open) {
            button.setAttribute('aria-expanded', 'false');
            content.style.display = 'none';
            button.innerHTML = button.getAttribute('data-label-more');
        } else {
            button.setAttribute('aria-expanded', 'true');
            content.style.display = 'block';
            button.innerHTML = button.getAttribute('data-label-less');
        }
    }

    function enableShowMore(wrapper) {
        let button = wrapper.querySelector('.js-show-more-button');
        let content = wrapper.querySelector('.js-show-more-content');

        if (!button || !content) {
            return;
        }

        /**
         * Prevent adding the listener more than once by checking and setting an expando
         * property on the element.
         *
         * @see https://developer.mozilla.org/en-US/docs/Glossary/Expando
         */
        if (button.hasShowMoreListener) {
            return;
        }
        button.hasShowMoreListener = true;

        button.addEventListener('click', () => {
            buttonPressed(button, content);
        });
    }

    /**
     * Makes all "Show more" elements inside the supplied element open and close when clicked.
     *
     * This function may need to be reaplied if the DOM is manipulated using JavaScript.
     *
     * @param {*} el An element
     */
    function enableShowMoreElements(el) {
        el.querySelectorAll('.js-show-more').forEach((show_more_element) => {
            enableShowMore(show_more_element);
        });
    }

    // return an object to expose inner functions
    return {
        enableShowMoreElements: enableShowMoreElements,
    };
})();
